import { useEffect } from 'react';

import { getOgScriptUrl } from './utils';

type UseOrdergrooveMsiOptions = {
    onLoad: () => void;
    onError: () => void;
    isOgCookieSet: boolean;
};

/**
 * Hook to load the Ordergroove MSI script.
 * @param onLoad
 * @param onError
 * @param isOgCookieSet - A flag indicating if the Ordergroove cookie is set.
 */
export function useOrdergrooveMsi({ onLoad, onError, isOgCookieSet }: UseOrdergrooveMsiOptions) {
    const scriptUrl = getOgScriptUrl();

    useEffect(() => {
        // If the script is already present, consider it loaded regardless of cookie state
        const existing = document.querySelector(`script[src="${scriptUrl}"]`);
        if (existing) {
            onLoad();
            return;
        }

        // If the cookie is not set, do not load the script
        // https://developer.ordergroove.com/docs/subscription-manager-tagging-and-authentication
        if (!isOgCookieSet) {
            return;
        }

        const script = document.createElement('script');
        script.src = scriptUrl;
        script.async = true;
        script.onload = () => onLoad();
        script.onerror = () => onError();
        document.body.appendChild(script);

        return () => {
            // Cleanup the script tag
            document.body.removeChild(script);
        };
    }, [onLoad, onError, isOgCookieSet, scriptUrl]);
}
